import { ServicesElems as S } from './constants';

export const GIPS = [
  {
    type: S.withImg,
    img: 'gips-1.jpg'
  },
  {
    type: S.withLine,
    text:
      'Гипсокартон является наиболее популярным материалом, с помощью которого проводится отделка помещений. Основным достоинством материала является легкость его обработки и простота монтажа. Гипсокартон дает возможность воплотить в жизнь любую фантазию дизайнера.'
  },
  {
    type: S.withTitle,
    text:
      '<p>У гипсокартона 3-х слойная структура: обе стороны материала оклеены особым типом картона, а посредине находится гипс. Материал производится в форме прямоугольных листов. На 93% гипсокартон состоит из гипса, а на 6% из картона, еще 1% — это поверхностное вещество, крахмал и вода.</p><p>Технология производства гипсокартона достаточно простая. На конвейер подаются верхний и нижний слои специального картона. Внутрь укладывается гипсовая масса, которая армирована специальными волокнами, после чего полоса прикатывается. Дальше она движется по конвейеру, пока не застынет. В это же время края зафальцовываются. После этого, с помощью гильотинных ножниц происходит нарезание листов, которые отправляются в сушилку. Сушатся листы на протяжении 1 часа. Во время выхода из сушки у листов выравнивают торцы согласно заданному размеру. Готовый гипсокартон пакуют и складывают в штабеля.</p><p>Гипсовая масса формируется из природного натурального минерала — гипса. Синтезированный или природный камень обжигается, в результате чего получается белый порошок, легко растворяющийся в воде. Гипс является экологически чистым материалом, он стоек к огню и не выделяет радиации. </p>'
  },
  {
    type: S.withList,
    title: 'Гипсокартон делится на следующие основные виды:',
    list: [
      'Обычный гипсокартон.',
      'Водостойкий гипсокартон.',
      'Огнеупорный гипсокартон.',
      'Влагоогнестойкий гипсокартон.'
    ]
  },
  {
    type: S.withTitle,
    text:
      'Также производится еще один вид гипсокартона — акустический. Гипсокартонные работы в Минске из акустического вида гипсокартона выполняются в том случае, когда необходимо создать оптимальный уровень звука внутри помещения. Достигается данный эффект за счет изготовления перфорированной структуры покрытия, одна из частей которого является нетканым полотном. '
  },
  {
    type: S.withList,
    title:
      'Исходя из основного предназначения материала — создание препятствия отражению шумовых волн от стен, этот вид гипсокартона может быть использован для отделки:',
    list: [
      'концертных залов и кинотеатров;',
      'репетиционных классов;',
      'музыкальных учреждений;',
      'научных и учебных аудиторий;',
      'комнат для переговоров.'
    ]
  },
  {
    type: S.withImg,
    img: 'gips-2.jpg'
  },
  {
    type: S.withTitle,
    title: 'ПРИМЕНЕНИЕ ГИПСОКАРТОНА'
  },
  {
    type: S.withImg,
    img: 'gips-3.jpg'
  },
  {
    type: S.withList,
    title: 'Из гипсокартона можно сделать:',
    list: [
      'Межкомнатные перегородки на металлическом или деревянном каркасе,',
      'Любой вид потолка: подвесной, многоуровневый, с декоративными элементами и т.д.',
      'Гипсокартон очень легко согнуть (для этого его необходимо просто смочить водой) – благодаря этой способности ГКЛ часто используют при создании сложных декоративных элементов',
      'Из гипсокартона можно выровнять новые, обновить старые стены и перегородки',
      'Откосы',
      'И т.д.'
    ]
  },
  {
    type: S.withImg,
    img: 'gips-4.jpg'
  },
  {
    type: S.withImg,
    img: 'gips-5.jpeg'
  },
  {
    type: S.withImg,
    img: 'gips-6.jpeg'
  },
  {
    type: S.withImg,
    img: 'gips-7.jpeg'
  },
  {
    type: S.withImg,
    img: 'gips-8.jpeg'
  },
  {
    type: S.withImg,
    img: 'gips-9.jpeg'
  },
  {
    type: S.withImg,
    img: 'gips-10.jpeg'
  },
  {
    type: S.withImg,
    img: 'gips-11.jpeg'
  }
];
